export const issn = '20010';
export const token_type = 'token';
export const url_dev = 'http://192.168.217.77:8881';
export const url_production = 'https://api-m3g-activity.17m3.com';